import React, { useMemo } from 'react';
import { FaClosedCaptioning } from 'react-icons/fa6';
import BaseModal from '../basemodal';
import useIsMobile from '../../hooks/useIsMobile';
import Linkify from 'linkify-react';
import Text from '../text';
import Subtitle from '../subtitle';
import moment from 'moment';
import Title from '../title';

type PostProps = {
  data: any;
  closePost: () => void;
};

export default function Post({ data, closePost }: PostProps) {

  const isMobile = useIsMobile();
  const image = data.images?.[0]?.image;
  const pdfs = data.pdfs;

  const date = useMemo(() => {
    return moment(data.date.replace('Z', '')).format('DD/MM/YYYY - HH:mm')
  }, [data.date])

  return (
    <BaseModal
      closeModal={closePost}
      width={isMobile ? '100%' : '65%'} height={isMobile ? '100%' : ''} >
      <div className='flex flex-1 flex-col mx-5 mb-5 px-[32px] pb-[20px] h-full max-[1024px]:px-[10px]'>

        {image && (
          <div className="w-full mt-6 mb-2.5 rounded-[18px] overflow-hidden bg-[#f4f4f4]">
            <img
              src={image}
              className="w-full max-h-[420px] object-contain"
            />
          </div>
        )}

        <Title className='!mt-2.5 !mb-2 !text-[1.25rem] !leading-[24px] !font-bold'>{data.title}</Title>
        <Subtitle className='!m-0 !text-[0.6875rem] !font-medium !text-[#999]'>{date}</Subtitle>

        <Linkify options={{ target: '_blank' }}>
          <Text className='!mt-[28px] !text-[0.9375rem] !leading-[28.5px] !whitespace-pre-wrap'>{data.body}</Text>
        </Linkify>

        {pdfs?.length > 0 && (
          <div className="mt-4 flex flex-col gap-2">
            <Subtitle className='!text-[1rem] !font-bold'>Documentos</Subtitle>

            {pdfs.map((pdf: any, index: number) => (
              <div key={index}>
                <a
                  href={pdf.pdf}
                  target="_blank"
                  rel="noreferrer"
                  className='text-gray-700 text-[0.9375rem]'
                >
                  {pdf.name}
                </a>
              </div>
            ))}
          </div>
        )}
      </div>
    </BaseModal>
  );
}
